import { environment } from "../../../environments/environment";
import Amplify, { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "aws-amplify/lib/API/types";
import { TableConstants } from "../../constants/table-constants";
import { HttpClient } from "@angular/common/http";
import { HttpUtilsService } from "../../service/httputils.service";
import { Injectable } from "@angular/core";
let url = environment.pg_dburl[window.location.origin];
export const CRUD = {
  CREATE: "create",
  LIST: "list",
  GET: "get",
  UPDATE: "update",
  DELETE: "delete",
};
/**
 * AWS Provider for Driver Attendance
 */

@Injectable({
  providedIn: "root",
})
export class AwsAppServiceProvider {
  /**
   * TAG name for this Page
   */
  private TAG = "AwsAppServiceProvider";

  private QUERY_KEY = {
    GET_APP_LIST: CRUD.GET + environment.dbPrefix + "CpRnFcmToken",
    CREATE_APP: CRUD.CREATE + environment.dbPrefix + "CpRnFcmToken",
    UPDATE_APP: CRUD.UPDATE + environment.dbPrefix + "CpRnFcmToken",
  };
  constructor(private httpUtils: HttpUtilsService) {
    // console.log('[INFO] ' + this.TAG + ' - AWS : Mode : ', environment.mode);
    // console.log(
    //   '[INFO] ' + this.TAG + ' - AWS : AWS Config : ',
    //   environment.awsConfig
    // );
    // Amplify.configure(environment.awsConfig);

    let myAppConfig = environment.myAppConfig;
    Amplify.configure(myAppConfig);
  }
  /************************************************************
   * Queries for Driver Attendance
   ************************************************************/

  private GetAppFCMToken =
    `query ` +
    this.QUERY_KEY.GET_APP_LIST +
    `($rn_number: String!) {
  ` +
    this.QUERY_KEY.GET_APP_LIST +
    `(rn_number:$rn_number) {
          rn_number
          fcm_token
          email
          user_name
          created_on
          updated_on
  }
  }`;

  // fcm_token: String,
  // user_name: String,
  // email: String,
  // created_on: AwsDate,
  // updated_on: AwsDate
  // $created_on: String,
  // $updated_on: String
  // created_on: $created_on
  // updated_on: $updated_on

  private createFCMToken =
    `mutation ` +
    this.QUERY_KEY.CREATE_APP +
    `($rn_number: String!,
      $fcm_token: String,
  $user_name: String,
  $email: String,
  $created_on: AWSDateTime,
  $updated_on: AWSDateTime
  ) {
` +
    this.QUERY_KEY.CREATE_APP +
    `(input:{
      rn_number: $rn_number
      fcm_token: $fcm_token
      user_name: $user_name
      email: $email
      created_on: $created_on
      updated_on: $updated_on
}) {
    rn_number
    fcm_token
    user_name
    email
    created_on
    updated_on
}

}`;

  public async listApplicationServices(rnNumber: string): Promise<any> {
    const tablename = TableConstants.cpRnFcmToken;
    const endpoint = `${url}/${tablename}?data->>rn_number=eq.${rnNumber}`;
    try {
      const response = await this.httpUtils.get<any[]>(endpoint);
      return response && response.length > 0 ? response[0] : null;
    } catch (error) {
      console.error("Error fetching FCM token list:", error);
      throw error;
    }
  }

  public async applicationFCMTokeCreate(tokenDB: any): Promise<any> {
    const tablename = TableConstants.cpRnFcmToken;
    const endpoint = `${url}/${tablename}?select=*`;
    const payload = {
      data: {
        rn_number: tokenDB.rn_number,
        fcm_token: tokenDB.fcm_token,
        user_name: tokenDB.user_name,
        email: tokenDB.email,
        created_on: tokenDB.created_on,
        updated_on: tokenDB.updated_on,
      },
      created_date: tokenDB.created_on,
      updated_date: tokenDB.updated_on,
    };

    try {
      const response = await this.httpUtils
        .post<any[]>(endpoint, payload);
      return Array.isArray(response) && response.length > 0
        ? response[0]
        : null;
    } catch (error) {
      console.error("Error creating FCM token:", error);
      throw error;
    }
  }
}
